export default {
  errorPayments: {
    title: "Виправлення та рознесення помилкових платежів",
    errorPaymentsForm: {
      modal: {
        title: "Виправлення та рознесення помилкових платежів"
      },
      autoDistribute: "F2 - Автоматично рознести платіж після зміни"
    }
  }
};
